import React from "react";
import { Header, Segment } from "semantic-ui-react";
import { bestGuessHostedInDevelopment } from "../../../../sg-core/utils/enviroment.helpers";
import "./_FullPageLoader.less";

interface FullPageLoaderProps {
    loaderKey?: string;
    title?: string;
    description?: string;
    fixed?: boolean;
};

export const FullPageLoader: React.FC<FullPageLoaderProps> = ({
    loaderKey = "uknown",
    title,
    description,
    fixed = false
}) => {
    if (bestGuessHostedInDevelopment) {
        //  console.log("[FullPageLoader]", { loaderKey, title, description });
    };
    return (
        <Segment
            className={"FullPageLoader" + (fixed ? " fixed" : "")}
            textAlign="center"
            placeholder
            basic
            loading
            style={{ minHeight: "400px" }}
        >
            <Header >{title}</Header>
            {description && <p> {description} </p>}
        </Segment >
    );
};

export const defaultFullPageLoader = <FullPageLoader title="" description="" />;